<template>
  <v-app v-if="authenticated">
    <Header
      :clipped="true"
      :drawer="false"
      :fixed="true"
      :items="pages"
      v-if="showHeader"
      ref="childComponent"
    />
    <v-content>
      <router-view v-on:refreshMenu="updateMenu"></router-view>
    </v-content>

    <VersionModal v-model="showVersionModal" />
  </v-app>
</template>

<script>
import Header from "./layout/header";
import VersionModal from "./components/VersionModal.vue";
import { initVersionCheck } from "./services/versionCheck";

export default {
  name: "app",
  components: { Header, VersionModal },

  data() {
    return {
      pages: [],
      authenticated: false,
      showVersionModal: false,
    };
  },

  async created() {
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.authenticated = this.$GAUserAuth.user.isAuthenticated;
    });

    initVersionCheck(() => {
      this.showVersionModal = true;
    });
  },

  computed: {
    showHeader: function () {
      return this.$store.getters.GET_showHeader;
    },
  },

  methods: {
    updateMenu(refresh) {
      this.$refs.childComponent.updateMenu();
    },
  },
};
</script>

<style scoped>
@import "./css/style.css";
</style>

<!--<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Vuetify</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">Latest Release</span>
      </v-btn>
    </v-toolbar>

    <v-content>
      <Grid
        controller="values/"
        readAll="ReadAll"
        :customFilters="customFilters"
        :title="controller"
        :CanCreate="false"
        :disableEdit="true"
        :disableDelete="true"

        :refresh="reloadGridData"
      >
      <template v-slot:default="child">
        <li @click="Download(child)">
          <i class="fas fa-cloud-download-alt"></i>
          <span>&nbsp; Download</span>
        </li>
        <li @click="CopyInOtherRep(child)">
          <i class="fas fa-copy"></i>
          <span>&nbsp; Copia in altro repository</span>
        </li>
        <li @click="MoveInOtherRep(child)">
          <i class="fas fa-file-import"></i>
          <span>&nbsp; Sposta in altro repository</span>
        </li>
        <li
          v-if="child.child.data&&!child.child.data.name.logicDeleteDate"
          @click="LogicDelete(child)"
        >
          <i class="fas fa-archive"></i>
          <span>&nbsp; Elimina logicamente</span>
        </li>
        <li @click="PermanentDelete(child)">
          <i class="fas fa-trash"></i>
          <span>&nbsp; Elimina fisicamente</span>
        </li>
        <li v-if="child.child.data&&child.child.data.name.logicDeleteDate" @click="Restore(child)">
          <i class="fas fa-trash-restore"></i>
          <span>&nbsp; Ripristina</span>
        </li>
        <li @click="FunctionalData(child)">
          <i class="fas fa-cogs"></i>
          <span>&nbsp; Dati funzionali</span>
        </li>
      </template>
      
      </Grid>
    </v-content>
  </v-app>
</template>

// <script>
// import Grid from "./components/gridComponent";
// export default {
//   name: "App",
//   components: {
//     Grid
//   },
//   data() {
//     return {
//       headers: [],
//       customFilters: [
//         { text: "Larghezza", value: "Width", type: Number },
//         { text: "Altezza", value: "Height", type: Number },
//         { text: "Cancellazione Logica", value: "LogicDelete", type: Boolean }
//       ],
//       reloadGridData: false,
//       controller: "values",
//       readMethod: "readall"
//     };
//   }
// };
// </script>
-->